export default "__VITE_ASSET__DdQOrDCL__"